import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { ResiduoPeligrosoSchema } from "../data/ResiduoPeligrosoSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import TypeaheadField from "./controls/TypeaheadField";
import ArrayField from "./controls/ArrayField";
import AmmountField from "./controls/AmmountField";
import CheckboxField from "./controls/CheckboxField";
import TextField from "./controls/TextField";
import SelectField from "./controls/SelectField";
import Pagination from "./controls/Pagination";
import { isInvalid } from "../utils/forms";
import Button from "./controls/Button";

import { CaracteristicaPeligrosidadForm } from "./CaracteristicaPeligrosidadForm";

export function ResiduoPeligrosoForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  operacionesUnitarias,
  corrientes,
  caracteristicasPeligrosidad,
  unidadCantidad,
  tecnologias,
  disabled,
}) {
  const { t } = useTranslation();
  const handleCorrienteChange = (form) => (event) => {
    form.handleChange(event);
  };
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={ResiduoPeligrosoSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(form) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("residuoPeligrosoForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <TypeaheadField
                id="residuoPeligroso_corriente"
                name="corriente"
                style={{
                  margin: 0,
                }}
                value={form.values.corriente}
                onChange={handleCorrienteChange(form)}
                options={corrientes}
                labelAttr={(value) => `(${value.codigo}) ${value.nombre}`}
                valueAttr="codigo"
                emptyLabel="..."
                isInvalid={isInvalid("corriente", form)}
                error={t(form.errors.corriente)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <ArrayField
                id="residuoPeligroso_peligrosidad"
                name="peligrosidad"
                label={t("residuoPeligroso.peligrosidad")}
                value={form.values.peligrosidad}
                onChange={(event) => form.handleChange(event)}
                isInvalid={isInvalid("peligrosidad", form)}
                error={t(form.errors.peligrosidad)}
                disabled={disabled}
              >
                {({ value, append, remove, disabled }) => (
                  <CaracteristicaPeligrosidadForm
                    value={value}
                    append={append}
                    remove={remove}
                    caracteristicasPeligrosidad={caracteristicasPeligrosidad}
                    disabled={disabled}
                  />
                )}
              </ArrayField>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <AmmountField
                id="residuoPeligroso_cantidad"
                name="cantidad"
                label={t("residuoPeligroso.cantidad")}
                value={form.values?.cantidad}
                onChange={(event) => form.handleChange(event)}
                unit={unidadCantidad}
                isInvalid={isInvalid("cantidad", form)}
                error={t(form.errors.cantidad)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <CheckboxField
                id="residuoPeligroso_operacionesUnitarias"
                name="operacionesUnitarias"
                label={t("residuoPeligroso.operacionesUnitarias")}
                value={form.values?.operacionesUnitarias}
                onChange={(event) => form.handleChange(event)}
                options={operacionesUnitarias}
                labelAttr="nombre"
                valueAttr="orden"
                lg={6}
                isInvalid={isInvalid("operacionesUnitarias", form)}
                error={t(form.errors.operacionesUnitarias)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField
                id="residuoPeligroso_descripcion"
                name="descripcion"
                label={t("residuoPeligroso.descripcion")}
                value={form.values?.descripcion}
                onChange={(event) => form.handleChange(event)}
                isInvalid={isInvalid("descripcion", form)}
                error={t(form.errors.descripcion)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <SelectField
                id="residuoPeligroso_tratamiento"
                name="tratamiento"
                label={t("residuoPeligroso.tratamiento")}
                value={form.values?.tratamiento}
                onChange={(event) => form.handleChange(event)}
                options={tecnologias}
                labelAttr={(value) => `${value.codigo} - ${value.nombre}`}
                valueAttr="codigo"
                emptyLabel="..."
                isInvalid={isInvalid("tratamiento", form)}
                error={t(form.errors.tratamiento)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("residuoPeligrosoForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("residuoPeligrosoForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("residuoPeligrosoForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    form.submitForm();
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("residuoPeligrosoForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
